// @core/api/endpoints/document/update_document.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentResponse,
  UpdateDocumentRequest,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Update document
 * Updates document fields. Changes are recorded in the audit log. Only draft or revision documents can be edited.
 */
export async function UpdateDocument(
  document_id: string,
  data: UpdateDocumentRequest,
  options?: RequestOptions
): Promise<DocumentResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/documents/:document_id`;
  requestPath = requestPath.replace(':document_id', encodeURIComponent(document_id));
  const requestOptions = options;
  return client.put<DocumentResponse>(requestPath, data, requestOptions);
}
